module.exports = __webpack_public_path__ + "static/media/Group.3b941000.png";